import { createAction, handleActions } from 'redux-actions';

const setSorting = createAction("SCREENS/SUPPLIERS/SET_SORTING");

const defaultState = {
  columnKey: 'company_name',
  order: 'ascend'
};

const reducer = handleActions(
  {
    [setSorting]: (state, action) => action.payload
  },
  defaultState
);

export { setSorting, reducer };
